export enum InfoIconMode {
  Always = 'always',
  Hover = 'hover',
  None = 'none',
}
